import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormOrderFromBoardComponent } from './form.component';
import { FieldsModule } from '../../fields/fields.module';
import { TypeProposalModule } from '../../fields/type-proposal/type-proposal.module';

@NgModule({
  declarations: [FormOrderFromBoardComponent],
  imports: [CommonModule, FieldsModule, TypeProposalModule],
  exports: [FormOrderFromBoardComponent],
})
export class FormOrderFromBoardModule {}
